// external-script.js
let script = document.createElement("script");
// script.src = "https://cdn.live2.ai/assets/sdk/latest/live2ai-embed-sdk.js";
script.defer = true;

// Append the script element to the document's head
document.head.appendChild(script);


